class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 50);

		const facetForm = this.querySelector("form");
		const shouldIgnoreFacetEvent = (event) => {
			if (event && event.target) {
				if (event.target.classList.contains("js-subcategory-toggle") || event.target.closest(".js-subcategory-toggle")) {
					return true;
				}
				if (event.target.classList.contains("js-custom-brand-checkbox") || event.target.closest(".js-custom-brand-checkbox")) {
					return true;
				}
			}
			return false;
		};

		facetForm.addEventListener("input", (event) => {
			if (shouldIgnoreFacetEvent(event)) return;
			this.debouncedOnSubmit(event);
		});
		facetForm.addEventListener("change", (event) => {
			if (shouldIgnoreFacetEvent(event)) return;
			this.debouncedOnSubmit(event);
		});

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

		const facetButton = this.querySelector(".facets__button-show");
		const dir = document.querySelector("html").getAttribute("dir");
		if (facetButton) {
			facetButton.onclick = (event) => {
				event.currentTarget
					.querySelector(".label-hide")
					.classList.toggle("hidden");
				event.currentTarget
					.querySelector(".label-show")
					.classList.toggle("hidden");
				if (!event.currentTarget.classList.contains("facets__button-show_up")) {
					if (
						event.currentTarget
							.querySelector(".label-hide")
							.classList.contains("hidden")
					) {
						if (dir !== "rtl") {
							let width =
								this.querySelector(".facets__container").offsetWidth + 32;
							this.querySelector(".facets__container").style.marginLeft = `-${
								width + 64
							}px`;
							document.querySelector(
								".products-grid"
							).style.marginLeft = `-${width}px`;
							document.querySelector(
								".facets__top"
							).style.marginLeft = `-${width}px`;
						} else {
							let width =
								this.querySelector(".facets__container").offsetWidth + 32;
							this.querySelector(".facets__container").style.marginRight = `-${
								width + 64
							}px`;
							document.querySelector(
								".products-grid"
							).style.marginRight = `-${width}px`;
							document.querySelector(
								".facets__top"
							).style.marginRight = `-${width}px`;
						}
					} else {
						if (dir !== "rtl") {
							this.querySelector(".facets__container").style.marginLeft = "0";
							document.querySelector(".products-grid").style.marginLeft = "0";
							document.querySelector(".facets__top").style.marginLeft = "0";
						} else {
							this.querySelector(".facets__container").style.marginRight = "0";
							document.querySelector(".products-grid").style.marginRight = "0";
							document.querySelector(".facets__top").style.marginRight = "0";
						}
					}
					if (document.querySelector(".products-grid"))
						document
							.querySelector(".products-grid")
							.classList.toggle("full-width");
					if (document.querySelector(".collection-results"))
						document
							.querySelector(".collection-results")
							.classList.toggle("full-width");
				} else {
					if (
						event.currentTarget
							.querySelector(".label-hide")
							.classList.contains("hidden")
					) {
						let height = this.querySelector(".facets__container").offsetHeight;
						this.querySelector(
							".facets__wrapper"
						).style.marginTop = `-${height}px`;
					} else {
						this.querySelector(".facets__wrapper").style.marginTop = "0";
					}
				}
			};

			const collectionGridSection =
				document.querySelector(".collection-grid-section") ||
				document.querySelector(".section-search");
			let prevWidth = 0;
			const sectionResizeObserver = new ResizeObserver((entries) => {
				const [entry] = entries;

				if (
					!facetButton.classList.contains("facets__button-show_up") &&
					entry.contentRect.width !== prevWidth
				) {
					if (
						facetButton
							.querySelector(".label-hide")
							.classList.contains("hidden")
					) {
						if (entry.contentRect.width > 749) {
							if (dir !== "rtl") {
								let width =
									this.querySelector(".facets__container").offsetWidth + 32;
								this.querySelector(".facets__container").style.marginLeft = `-${
									width + 64
								}px`;
								document.querySelector(
									".products-grid"
								).style.marginLeft = `-${width}px`;
								document.querySelector(
									".facets__top"
								).style.marginLeft = `-${width}px`;
							} else {
								let width =
									this.querySelector(".facets__container").offsetWidth + 32;
								this.querySelector(
									".facets__container"
								).style.marginRight = `-${width + 64}px`;
								document.querySelector(
									".products-grid"
								).style.marginRight = `-${width}px`;
								document.querySelector(
									".facets__top"
								).style.marginRight = `-${width}px`;
							}
						} else {
							if (dir !== "rtl") {
								this.querySelector(".facets__container").style.marginLeft = "0";
								document.querySelector(".products-grid").style.marginLeft = "0";
								document.querySelector(".facets__top").style.marginLeft = "0";
							} else {
								this.querySelector(".facets__container").style.marginRight =
									"0";
								document.querySelector(".products-grid").style.marginRight =
									"0";
								document.querySelector(".facets__top").style.marginRight = "0";
							}
						}
					}
				} else {
					if (
						facetButton
							.querySelector(".label-hide")
							.classList.contains("hidden") &&
						entry.contentRect.width !== prevWidth
					) {
						if (entry.contentRect.width > 749) {
							let height = this.querySelector(".facets__wrapper").offsetHeight;
							this.querySelector(
								".facets__wrapper"
							).style.marginTop = `-${height}px`;
							prevWidth = entry.contentRect.width;
						} else {
							this.querySelector(".facets__wrapper").style.marginTop = "0";
						}
					}
				}
			});
			sectionResizeObserver.observe(collectionGridSection);
		}

		document.addEventListener("click", (e) => {
			const detailsList = document.querySelectorAll(
				".facets__wrapper--horizontal .facets__disclosure"
			);
			const details = e.target.closest(".facets__disclosure[open]");

			if (!details && detailsList) {
				detailsList.forEach((item) => {
					item.removeAttribute("open");
				});
			}
		});
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);

		document.addEventListener("click", (event) => {
			const pageLink = event.target.closest(".pagination__item, .pagination__item-arrow");
			if (!pageLink) return;
			// If subcategory filter is active or button is a subcat pagination button, let subcategory script handle it
			if (document.querySelectorAll(".js-subcategory-toggle:checked").length > 0) return;
			if (pageLink.classList.contains("js-subcat-page-btn")) return;

			const href = pageLink.getAttribute("href");
			if (!href || href.startsWith("#") || href.startsWith("javascript:")) return;

			const searchIndex = href.indexOf("?");
			if (searchIndex !== -1) {
				event.preventDefault();
				const searchParams = href.slice(searchIndex + 1);
				FacetFiltersForm.renderPage(searchParams, event);
				const gridContainer = document.getElementById("ProductGridContainer");
				if (gridContainer) {
					gridContainer.scrollIntoView({ behavior: "smooth" });
				}
			}
		});
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true, useReplace = false) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		const gridContainer = document.getElementById("ProductGridContainer");
		if (gridContainer) {
			gridContainer.classList.add("is-filtering");
		}
		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams, useReplace);
	}

	static renderSectionFromFetch(url, event) {
  if (FacetFiltersForm.abortController) {
    FacetFiltersForm.abortController.abort();
  }

  FacetFiltersForm.abortController = new AbortController();

  fetch(url, {
    signal: FacetFiltersForm.abortController.signal
  })
    .then((response) => response.text())
    .then((responseText) => {
      const html = responseText;

      FacetFiltersForm.filterData = [
        ...FacetFiltersForm.filterData,
        { html, url },
      ];

      const parsedHTML = new DOMParser().parseFromString(html, "text/html");

      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      FacetFiltersForm.renderActiveFacets(parsedHTML);

      const newSort = parsedHTML.getElementById("SortBy");
      const currentSort = document.getElementById("SortBy");
      if (newSort && currentSort) {
        currentSort.value = newSort.value;
      }
      const newSortMobile = parsedHTML.getElementById("SortBy-mobile");
      const currentSortMobile = document.getElementById("SortBy-mobile");
      if (newSortMobile && currentSortMobile) {
        currentSortMobile.value = newSortMobile.value;
      }
    })
    .catch((error) => {
      if (error.name !== "AbortError") {
        console.error("Filter fetch failed:", error);
      }
    });
}



	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
	}
static renderProductGridContainer(html) {
  const gridContainer = document.getElementById("ProductGridContainer");

  gridContainer.innerHTML = new DOMParser()
    .parseFromString(html, "text/html")
    .getElementById("ProductGridContainer").innerHTML;

  if (
    document.querySelector(".js-load-more") ||
    document.querySelector(".js-infinite-scroll")
  ) {
    loadMore();
  }

  colorSwatches();

  if (typeof initCustomBrandFilter === 'function') {
    initCustomBrandFilter();
  }
  if (typeof window.applyBrandFiltering === 'function') {
    window.applyBrandFiltering();
  }
  if (typeof window.initCollectionGrouping === 'function') {
    window.initCollectionGrouping();
  }

  gridContainer.classList.remove("is-filtering");
}

	static renderProductCount(html) {
		const count = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductCount").innerHTML;
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");
		container.innerHTML = count;
		container.classList.remove("loading");
		if (containerDesktop) {
			containerDesktop.innerHTML = count;
			containerDesktop.classList.remove("loading");
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");

		const facetDetailsElements = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest(".js-filter") : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element)
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			document.querySelector(
				`.js-filter[data-index="${element.dataset.index}"]`
			).innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (typeof initCustomBrandFilter === 'function') {
			initCustomBrandFilter();
		}

		if (countsToRender)
			FacetFiltersForm.renderCounts(
				countsToRender,
				event.target.closest(".js-filter")
			);
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;
			document.querySelector(selector).innerHTML =
				activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
		];

		mobileElementSelectors.forEach((selector) => {
			if (!html.querySelector(selector)) return;
			document.querySelector(selector).innerHTML =
				html.querySelector(selector).innerHTML;
		});

		document
			.getElementById("FacetFiltersFormMobile")
			.closest("menu-drawer")
			.bindEvents();
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(".facets__selected");
		const sourceElement = source.querySelector(".facets__selected");

		const targetElementAccessibility = target.querySelector(".facets__summary");
		const sourceElementAccessibility = source.querySelector(".facets__summary");

		if (sourceElement && targetElement) {
			target.querySelector(".facets__selected").outerHTML =
				source.querySelector(".facets__selected").outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(".facets__summary").outerHTML =
				source.querySelector(".facets__summary").outerHTML;
		}
	}

	static updateURLHash(searchParams, useReplace = false) {
		const newUrl = `${window.location.pathname}${searchParams && "?".concat(searchParams)}`;
		if (useReplace) {
			history.replaceState({ searchParams }, "", newUrl);
		} else {
			history.pushState({ searchParams }, "", newUrl);
		}
	}

	static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		event.preventDefault();
		if (event.target && (event.target.classList.contains('js-custom-brand-checkbox') || event.target.classList.contains('js-subcategory-toggle') || event.target.closest('.js-subcategory-toggle'))) {
			return;
		}
		const sortFilterForms = document.querySelectorAll(
			"facet-filters-form form"
		);
		if (event.srcElement.className == "mobile-facets__checkbox") {
			const searchParams = this.createSearchParams(
				event.target.closest("form")
			);
			this.onSubmitForm(searchParams, event);
		} else {
			const forms = [];
			const isMobile =
				event.target.closest("form").id === "FacetFiltersFormMobile";

			sortFilterForms.forEach((form) => {
				if (!isMobile) {
					if (
						form.id === "FacetSortForm" ||
						form.id === "FacetFiltersForm" ||
						form.id === "FacetSortDrawerForm"
					) {
						const noJsElements = document.querySelectorAll(".no-js-list");
						noJsElements.forEach((el) => el.remove());
						forms.push(this.createSearchParams(form));
					}
				} else if (form.id === "FacetFiltersFormMobile") {
					forms.push(this.createSearchParams(form));
				}
			});
			let searchParams = forms.join("&");
			this.onSubmitForm(searchParams, event);
		}
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
				  );
		FacetFiltersForm.renderPage(url);
	}

	static initDefaultSort() {
		// Do not automatically force sort_by=manual or re-fetch on collection page loads
		return;
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll("input").forEach((element) =>
			element.addEventListener("change", this.onRangeChange.bind(this))
		);
		this.setMinAndMaxValues();
		this.controlSlider();
		this.controlInput();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll("input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute("max", maxInput.value);
		if (minInput.value) maxInput.setAttribute("min", minInput.value);
		if (minInput.value === "") maxInput.setAttribute("min", 0);
		if (maxInput.value === "")
			minInput.setAttribute("max", maxInput.getAttribute("max"));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute("min"));
		const max = Number(input.getAttribute("max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}

	fillSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		inputRangeWrappers.forEach((inputWrapper) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];

			const range = inputRangeTo.max - inputRangeTo.min;
			const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
			const toCurrent = inputRangeTo.value - inputRangeTo.min;
			const minRange = (fromCurrent / range) * 100;
			const maxRange = (toCurrent / range) * 100;

			inputWrapper.setAttribute(
				"style",
				`--range-min: ${minRange}%; --range-max: ${maxRange}%`
			);
		});
	}

	controlSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputRangeWrappers.forEach((inputWrapper, index) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];
			const inputNumberFrom =
				inputNumberWrappers[index].querySelectorAll(".field__input")[0];
			const inputNumberTo =
				inputNumberWrappers[index].querySelectorAll(".field__input")[1];

			inputRangeFrom.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputNumberFrom.value = from;
				}

				this.fillSlider();
			};

			if (Number(inputRangeTo.value) <= 0) {
				inputRangeTo.style.zIndex = 2;
			} else {
				inputRangeTo.style.zIndex = 0;
			}

			inputRangeTo.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
					inputRangeTo.value = from;
				}

				if (Number(inputRangeTo.value) <= 0) {
					inputRangeTo.style.zIndex = 2;
				} else {
					inputRangeTo.style.zIndex = 0;
				}

				this.fillSlider();
			};
		});
	}

	controlInput() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputNumberWrappers.forEach((inputWrapper, index) => {
			const inputsNumber = inputWrapper.querySelectorAll(".field__input");
			const inputNumberFrom = inputsNumber[0];
			const inputNumberTo = inputsNumber[1];
			const inputRangeFrom =
				inputRangeWrappers[index].querySelectorAll(".field__range")[0];
			const inputRangeTo =
				inputRangeWrappers[index].querySelectorAll(".field__range")[1];

			inputNumberFrom.oninput = () => {
				const from = parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (to && from > to) {
					inputRangeFrom.value = to;
				} else {
					inputRangeFrom.value = from;
				}

				this.fillSlider();
			};

			inputNumberTo.oninput = () => {
				const from = parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (to >= from) {
					inputRangeTo.value = to;
				} else {
					inputRangeTo.value = from;
				}

				this.fillSlider();
			};
		});
	}
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector("a");
		facetLink.setAttribute("role", "button");
		facetLink.addEventListener("click", this.closeFilter.bind(this));
		facetLink.addEventListener("keyup", (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		form.onActiveFilterClick(event);
	}
}

customElements.define("facet-remove", FacetRemove);

function initFacetsShowMore() {
  return; // 🔥 completely disable show more
	document.querySelectorAll(".js-filter").forEach(function (filter) {
		const list = filter.querySelector(".facets__list");
		if (!list) return;

		const items = list.querySelectorAll("li");
		const limit = list.classList.contains("facets__list--image") ? 2 : 3;

		if (items.length <= limit) return;

		const wasExpanded = filter.dataset.expanded === "true";

		items.forEach((item, index) => {
			if (!wasExpanded && index >= limit) {
				item.style.display = "none";
			} else {
				item.style.display = "";
			}
		});

		let button = list.nextElementSibling;
		if (button && button.classList.contains("show-more-btn")) {
			button.innerText = wasExpanded ? "Show Less" : "Show More";
			button.setAttribute("data-expanded", wasExpanded ? "true" : "false");
			return;
		}

		button = document.createElement("button");
		button.className = "show-more-btn";
		button.type = "button";
		button.innerText = wasExpanded ? "Show Less" : "Show More";
		button.setAttribute("data-expanded", wasExpanded ? "true" : "false");
		list.after(button);

		button.addEventListener("click", function () {
			const isExpanded = button.getAttribute("data-expanded") === "true";

			if (isExpanded) {
				items.forEach((item, index) => {
					// if (index >= limit) item.style.display = "none";
				});
				button.innerText = "Show More";
				button.setAttribute("data-expanded", "false");
				filter.dataset.expanded = "false";
			} else {
				items.forEach((item) => (item.style.display = ""));
				button.innerText = "Show Less";
				button.setAttribute("data-expanded", "true");
				filter.dataset.expanded = "true";
			}
		});
	});
}
document.addEventListener("DOMContentLoaded", initFacetsShowMore);

const origRenderFilters = FacetFiltersForm.renderFilters;
FacetFiltersForm.renderFilters = function (html, event) {
	origRenderFilters.call(this, html, event);
	initFacetsShowMore();
	initCustomColorFilter();
};

const origRenderProductGridContainer = FacetFiltersForm.renderProductGridContainer;
FacetFiltersForm.renderProductGridContainer = function (html) {
	origRenderProductGridContainer.call(this, html);
	initCustomColorFilter();
};

function initCustomColorFilter() {
	const checkboxes = document.querySelectorAll('.js-color-facet-checkbox');
	if (!checkboxes || checkboxes.length === 0) return;

	function getSelectedColors() {
		const checked = document.querySelectorAll('.js-color-facet-checkbox:checked');
		const colors = [];
		checked.forEach(cb => {
			const val = (cb.dataset.colorName || cb.value || '').toLowerCase().trim();
			if (val && !colors.includes(val)) {
				colors.push(val);
			}
		});
		return colors;
	}

	function updateActivePills(selectedColors) {
		const activeContainers = document.querySelectorAll('.js-active-color-facets');
		activeContainers.forEach(container => {
			if (selectedColors.length === 0) {
				container.innerHTML = '';
				return;
			}
			let html = '';
			selectedColors.forEach(col => {
				const capitalCol = col.charAt(0).toUpperCase() + col.slice(1);
				html += `
					<facet-remove style="margin-right: 0.6rem;">
						<a href="#" class="active-facets__button focus-inset js-color-pill-remove" data-color="${col}">
							<span class="active-facets__button-inner small-font">
								<span>Color:</span> ${capitalCol}
								<span class="active-facets__button-close">
									<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 10 10" width="10" height="10">
										<path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
									</svg>
								</span>
							</span>
						</a>
					</facet-remove>
				`;
			});
			container.innerHTML = html;

			container.querySelectorAll('.js-color-pill-remove').forEach(btn => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					const targetColor = btn.dataset.color;
					document.querySelectorAll(`.js-color-facet-checkbox[data-color-name="${targetColor}"]`).forEach(cb => {
						cb.checked = false;
					});
					applyFiltering();
				});
			});
		});

		const clearAllBtns = document.querySelectorAll('.js-clear-all-facets');
		const activeWrappers = document.querySelectorAll('.active-facets__wrapper');
		const hasServerActive = document.querySelector('.active-facets__button:not(.js-color-pill-remove)');
		const hasActiveFilters = selectedColors.length > 0 || !!hasServerActive;

		clearAllBtns.forEach(btn => {
			if (hasActiveFilters) {
				btn.classList.remove('hidden');
				btn.style.display = '';
			} else {
				btn.classList.add('hidden');
				btn.style.display = 'none';
			}
		});

		activeWrappers.forEach(wrap => {
			if (hasActiveFilters) {
				wrap.classList.add('active-facets__wrapper_margin');
			} else {
				wrap.classList.remove('active-facets__wrapper_margin');
			}
		});
	}

	function applyFiltering() {
		const selectedColors = getSelectedColors();
		const productGrid = document.getElementById('product-grid');
		if (!productGrid) return;
		const cards = productGrid.querySelectorAll('.collection-product-card');
		if (!cards || cards.length === 0) return;

		let visibleCount = 0;
		cards.forEach(cardWrapper => {
			const card = cardWrapper.querySelector('.product-card') || cardWrapper;
			const cardColors = (card.dataset.colors || '').toLowerCase();
			const title = (card.querySelector('.card__title') ? card.querySelector('.card__title').textContent : '').toLowerCase();

			if (selectedColors.length === 0) {
				cardWrapper.style.display = '';
				visibleCount++;
			} else {
				let isMatch = false;
				for (const col of selectedColors) {
					const colAlt = col === 'multicolour' ? 'multicolor' : (col === 'multicolor' ? 'multicolour' : col);
					if (cardColors.includes(col) || title.includes(col) || cardColors.includes(colAlt) || title.includes(colAlt)) {
						isMatch = true;
						const swatches = card.querySelectorAll('.color-swatch-link, .color-swatch');
						swatches.forEach(swatch => {
							const sColor = (swatch.dataset.color || swatch.getAttribute('title') || '').toLowerCase();
							if (sColor === col) {
								swatch.classList.add('active');
								const img = card.querySelector('.media--first') || card.querySelector('.card__media img');
								if (img && swatch.dataset.imageSrc) {
									img.src = swatch.dataset.imageSrc;
									img.removeAttribute('srcset');
								}
							}
						});
						break;
					}
				}

				if (isMatch) {
					cardWrapper.style.display = '';
					visibleCount++;
				} else {
					cardWrapper.style.display = 'none';
				}
			}
		});

		updateActivePills(selectedColors);

		const countDesktop = document.getElementById('ProductCountDesktop');
		if (countDesktop) {
			if (selectedColors.length > 0) {
				countDesktop.textContent = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;
			}
		}
	}

	checkboxes.forEach(cb => {
		if (cb.dataset.filterAttached) return;
		cb.dataset.filterAttached = 'true';

		cb.addEventListener('change', () => {
			const colorVal = (cb.dataset.colorName || cb.value || '').toLowerCase().trim();
			document.querySelectorAll(`.js-color-facet-checkbox[data-color-name="${colorVal}"]`).forEach(otherCb => {
				otherCb.checked = cb.checked;
			});
			applyFiltering();
		});
	});

	document.querySelectorAll('.active-facets__button-remove').forEach(btn => {
		if (btn.dataset.filterAttached) return;
		btn.dataset.filterAttached = 'true';
		btn.addEventListener('click', (e) => {
			const hasServerActive = document.querySelector('.active-facets__button:not(.js-color-pill-remove)');
			document.querySelectorAll('.js-color-facet-checkbox').forEach(cb => {
				cb.checked = false;
			});
			applyFiltering();
			if (!hasServerActive) {
				e.preventDefault();
			}
		});
	});

	const urlParams = new URLSearchParams(window.location.search);
	const colorParam = urlParams.get('filter.v.option.color');
	if (colorParam) {
		const colLower = colorParam.toLowerCase().trim();
		document.querySelectorAll(`.js-color-facet-checkbox[data-color-name="${colLower}"]`).forEach(cb => {
			cb.checked = true;
		});
		applyFiltering();
	}
}

document.addEventListener('DOMContentLoaded', initCustomColorFilter);

function initCustomBrandFilter() {
	const brandCheckboxes = document.querySelectorAll('.js-custom-brand-checkbox');
	if (!brandCheckboxes.length) return;

	function getSelectedBrands() {
		const selected = [];
		document.querySelectorAll('.js-custom-brand-checkbox:checked').forEach(cb => {
			const b = (cb.dataset.brandName || cb.value || '').toLowerCase().trim();
			if (b && !selected.includes(b)) {
				selected.push(b);
			}
		});
		return selected;
	}

	function updateBrandActivePills(selectedBrands) {
		const containers = document.querySelectorAll('.js-active-brand-facets');
		if (!containers.length) return;

		let html = '';
		selectedBrands.forEach(brand => {
			const displayBrand = brand.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
			html += `
				<facet-remove>
					<a href="#" class="active-facets__button focus-inset js-brand-pill-remove" data-brand="${brand}">
						<span class="active-facets__button-inner small-font">
							<span>Brand:</span> ${displayBrand}
							<span class="active-facets__button-close">
								<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 10 10" width="10" height="10">
									<path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
								</svg>
							</span>
						</span>
					</a>
				</facet-remove>
			`;
		});

		containers.forEach(container => {
			container.innerHTML = html;
			container.querySelectorAll('.js-brand-pill-remove').forEach(btn => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					const targetBrand = btn.dataset.brand;
					document.querySelectorAll(`.js-custom-brand-checkbox[data-brand-name="${targetBrand}"]`).forEach(cb => {
						cb.checked = false;
					});
					applyBrandFiltering();
				});
			});
		});

		const clearAllBtns = document.querySelectorAll('.js-clear-all-facets');
		const activeWrappers = document.querySelectorAll('.active-facets__wrapper');
		const hasServerActive = document.querySelector('.active-facets__button:not(.js-brand-pill-remove):not(.js-color-pill-remove)');
		const hasActive = selectedBrands.length > 0 || !!hasServerActive;

		clearAllBtns.forEach(btn => {
			if (hasActive) {
				btn.classList.remove('hidden');
				btn.style.display = '';
			} else {
				btn.classList.add('hidden');
				btn.style.display = 'none';
			}
		});

		activeWrappers.forEach(wrap => {
			if (hasActive) {
				wrap.classList.add('active-facets__wrapper_margin');
			} else {
				wrap.classList.remove('active-facets__wrapper_margin');
			}
		});
	}

	function applyBrandFiltering() {
		const selectedBrands = getSelectedBrands();
		const productGrid = document.getElementById('product-grid');
		if (!productGrid) return;
		const cards = productGrid.querySelectorAll('.collection-product-card');
		if (!cards || cards.length === 0) return;

		let visibleCount = 0;
		cards.forEach(cardWrapper => {
			const card = cardWrapper.querySelector('.product-card') || cardWrapper;
			const cardBrand = (card.dataset.brand || '').toLowerCase();
			const title = (card.querySelector('.card__title') ? card.querySelector('.card__title').textContent : '').toLowerCase();

			let isMatch = false;
			if (selectedBrands.length === 0) {
				isMatch = true;
			} else {
				for (const b of selectedBrands) {
					if (cardBrand.includes(b) || (b.includes('dumpling') && title.includes('dumpling'))) {
						isMatch = true;
						break;
					}
				}
			}

			if (isMatch) {
				cardWrapper.style.display = '';
				visibleCount++;
			} else {
				cardWrapper.style.display = 'none';
			}
		});

		updateBrandActivePills(selectedBrands);

		const countDesktop = document.getElementById('ProductCountDesktop');
		if (countDesktop) {
			if (selectedBrands.length > 0) {
				countDesktop.textContent = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;
			}
		}
	}

	brandCheckboxes.forEach(cb => {
		if (cb.dataset.filterAttached) return;
		cb.dataset.filterAttached = 'true';

		cb.addEventListener('change', (e) => {
			e.stopPropagation();
			const brandVal = (cb.dataset.brandName || cb.value || '').toLowerCase().trim();
			document.querySelectorAll(`.js-custom-brand-checkbox[data-brand-name="${brandVal}"]`).forEach(otherCb => {
				otherCb.checked = cb.checked;
			});
			applyBrandFiltering();
		});
	});

	document.querySelectorAll('.active-facets__button-remove').forEach(btn => {
		if (btn.dataset.brandFilterAttached) return;
		btn.dataset.brandFilterAttached = 'true';
		btn.addEventListener('click', (e) => {
			const hasServerActive = document.querySelector('.active-facets__button:not(.js-brand-pill-remove):not(.js-color-pill-remove)');
			document.querySelectorAll('.js-custom-brand-checkbox').forEach(cb => {
				cb.checked = false;
			});
			applyBrandFiltering();
			if (!hasServerActive) {
				e.preventDefault();
			}
		});
	});

	const urlParams = new URLSearchParams(window.location.search);
	const vendorParam = (urlParams.get('filter.p.vendor') || urlParams.get('filter.p.vendor.custom') || '').toLowerCase().trim();
	if (vendorParam && vendorParam.includes('dumpling')) {
		document.querySelectorAll('.js-custom-brand-checkbox').forEach(cb => {
			cb.checked = true;
		});
		applyBrandFiltering();
	}

	window.applyBrandFiltering = applyBrandFiltering;
}

document.addEventListener('DOMContentLoaded', initCustomBrandFilter);

FacetFiltersForm.abortController = null;
